customElements.whenDefined('sc-purchase-timeline').then(() => {
  if (customElements.get('sc-cart-delivery')) return;
  const PurchaseTimeline = customElements.get('sc-purchase-timeline');

  class CartDelivery extends PurchaseTimeline {
    connectedCallback() {
      this.openObserver?.disconnect();
      super.connectedCallback();
      const drawer = this.closest('cart-drawer');
      if (!drawer) return;
      this.wasOpen = drawer.classList.contains('is-open');
      this.openObserver = new MutationObserver(() => {
        const open = drawer.classList.contains('is-open');
        if (open && !this.wasOpen) this.refresh();
        this.wasOpen = open;
      });
      this.openObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    disconnectedCallback() {
      this.openObserver?.disconnect();
      super.disconnectedCallback();
    }
  }

  customElements.define('sc-cart-delivery', CartDelivery);
});
